import styled, { css } from 'styled-components';

export const LogoWrapper = styled.img`
  position: absolute;
  top: 40px;
  left: 60px;
  height: 175px;
  ${props => props.isDriver && css`
    height: auto;
    width: 180px;
  `};
  ${props => props.margin && css`
    margin: ${props.margin};
  `};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    height: 85px;
    top: 5px;
    ${props => props.isDriver && css`
      height: 50px;
      top: 40px;
      width: auto;
    `};
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
`;



// WEBPACK FOOTER //
// ./src/lib/components/shared/TeamBigLogo/styles.js